export default "__VITE_ASSET__e3d3fb75__"